<aside class="vc-sidebar" [class.vc-sidebar--open]="isOpen">
  <div class="vc-sidebar__brand">
    <img
      src="assets/images/branding/virtualcenter-logo-horizontal-blanco.png"
      alt="Virtualcenter"
      width="192"
      height="35"
      class="vc-sidebar__brand-logo"
    />
  </div>

  <!-- Close button (mobile) -->
  <button
    class="vc-sidebar__close"
    (click)="closeSidebar.emit()"
    [attr.aria-label]="'SIDEBAR.CLOSE_MENU' | translate"
  >
    <i class="fas fa-times"></i>
  </button>

  <!-- ========================================== -->
  <!-- CLINIC SELECTOR (Top) -->
  <!-- ========================================== -->
  @if (!isPatientMode) {
  <div class="vc-sidebar__clinic-selector">
    <button
      class="vc-sidebar__clinic-btn"
      (click)="toggleSiteSelector()"
      [attr.aria-expanded]="isSiteSelectorOpen"
    >
      <div class="vc-sidebar__clinic-icon">
        <i class="fas fa-clinic-medical"></i>
      </div>
      <div class="vc-sidebar__clinic-info">
        <span class="vc-sidebar__clinic-name">{{
          site?.name || ("SIDEBAR.SELECT_CLINIC" | translate)
        }}</span>
        <span class="vc-sidebar__clinic-customer">{{ customer?.name }}</span>
      </div>
      <i
        class="fas fa-chevron-down vc-sidebar__clinic-chevron"
        [class.rotated]="isSiteSelectorOpen"
      ></i>
    </button>

    <!-- Clinic dropdown -->
    @if (isSiteSelectorOpen) {
    <div class="vc-sidebar__clinic-dropdown">
      @for (cust of availableCustomers; track cust.id) {
      <div class="vc-sidebar__clinic-group">
        @if (availableCustomers.length > 1) {
        <div class="vc-sidebar__clinic-group-title">{{ cust.name }}</div>
        } @for (s of getSitesForCustomer(cust); track s.id) {
        <button
          class="vc-sidebar__clinic-option"
          [class.active]="s.id === site?.id"
          [disabled]="switchingSiteId !== null"
          (click)="selectSite(cust, s)"
        >
          <i class="fas fa-map-marker-alt"></i>
          <span>{{ s.name }}</span>
          @if (s.id === site?.id) {
          <i class="fas fa-check vc-sidebar__clinic-check"></i>
          }
        </button>
        }
      </div>
      }
    </div>
    }
  </div>
  }

  <!-- ========================================== -->
  <!-- MAIN NAVIGATION -->
  <!-- ========================================== -->
  <nav class="vc-sidebar__nav">
    <div class="vc-sidebar__section">
      <ul class="vc-sidebar__menu" role="menu">
        @for (item of mainMenuItems; track item.id) {
        <li class="vc-sidebar__menu-item" role="none">
          <a
            class="vc-sidebar__link"
            [class.active]="isItemActive(item)"
            [routerLink]="item.routerLink"
            (click)="navigateTo(item)"
            role="menuitem"
            pRipple
          >
            <i [class]="item.icon" class="vc-sidebar__link-icon"></i>
            <span class="vc-sidebar__link-label">{{ item.label }}</span>
          </a>
        </li>
        }
      </ul>
    </div>

    <!-- ========================================== -->
    <!-- ADMIN SECTION (Collapsible) -->
    <!-- ========================================== -->
    @if (adminMenuItems.length > 1) {
    <div class="vc-sidebar__section vc-sidebar__section--admin">
      <button
        class="vc-sidebar__section-header"
        (click)="toggleAdminSection()"
        [attr.aria-expanded]="isAdminSectionExpanded"
      >
        <div class="vc-sidebar__section-header-left">
          <i class="fas fa-cogs vc-sidebar__section-icon"></i>
          <span class="vc-sidebar__section-title">{{
            "MENU.ADMIN" | translate
          }}</span>
        </div>
        <i
          class="fas fa-chevron-down vc-sidebar__section-chevron"
          [class.rotated]="isAdminSectionExpanded"
        ></i>
      </button>

      @if (isAdminSectionExpanded) {
      <ul class="vc-sidebar__menu vc-sidebar__menu--sub" role="menu">
        @for (item of adminMenuItems; track item.id) {
        <li class="vc-sidebar__menu-item" role="none">
          <a
            class="vc-sidebar__link vc-sidebar__link--sub"
            [class.active]="isItemActive(item)"
            [routerLink]="item.routerLink"
            (click)="navigateTo(item)"
            role="menuitem"
            pRipple
          >
            <i [class]="item.icon" class="vc-sidebar__link-icon"></i>
            <span class="vc-sidebar__link-label">{{ item.label }}</span>
          </a>
        </li>
        }
      </ul>
      }
    </div>
    } @else if (adminMenuItems.length === 1) {
    <div class="vc-sidebar__section vc-sidebar__section--admin">
      <ul class="vc-sidebar__menu" role="menu">
        <li class="vc-sidebar__menu-item" role="none">
          <a
            class="vc-sidebar__link"
            [class.active]="isItemActive(adminMenuItems[0])"
            [routerLink]="adminMenuItems[0].routerLink"
            (click)="navigateTo(adminMenuItems[0])"
            role="menuitem"
            pRipple
          >
            <i [class]="adminMenuItems[0].icon" class="vc-sidebar__link-icon"></i>
            <span class="vc-sidebar__link-label">{{ adminMenuItems[0].label }}</span>
          </a>
        </li>
      </ul>
    </div>
    }
  </nav>

  <!-- ========================================== -->
  <!-- BOTTOM SECTION (User & Settings) -->
  <!-- ========================================== -->
  <div class="vc-sidebar__bottom">
    @if (!isPatientMode) {
    <a
      class="vc-sidebar__link"
      routerLink="/profile"
      (click)="goToProfile()"
      pRipple
    >
      <i class="fas fa-user vc-sidebar__link-icon"></i>
      <span class="vc-sidebar__link-label">{{
        "MENU.PROFILE" | translate
      }}</span>
    </a>
    } @else {
    @if (canSwitchMode) {
    <button class="vc-sidebar__link" (click)="switchMode()" pRipple>
      <i class="fas fa-exchange-alt vc-sidebar__link-icon"></i>
      <span class="vc-sidebar__link-label">{{
        "PATIENT_SPACE.NAV.CHANGE_MODE" | translate
      }}</span>
    </button>
    }
    }

    <button
      class="vc-sidebar__link vc-sidebar__link--logout"
      (click)="logout()"
      pRipple
    >
      <i class="fas fa-sign-out-alt vc-sidebar__link-icon"></i>
      <span class="vc-sidebar__link-label">{{
        "MENU.LOGOUT" | translate
      }}</span>
    </button>

    <!-- User info -->
    <div class="vc-sidebar__user">
      <div class="vc-sidebar__user-avatar">
        <i class="fas fa-user"></i>
      </div>
      <div class="vc-sidebar__user-info">
        <span class="vc-sidebar__user-name">{{ user?.name }}</span>
        <span class="vc-sidebar__user-email">{{ user?.email }}</span>
      </div>
    </div>
  </div>
</aside>

<p-dialog
  [(visible)]="showModeDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [style]="{ width: 'min(26rem, calc(100vw - 2rem))' }"
  styleClass="vc-switch-mode-dialog"
>
  <ng-template pTemplate="header">
    <span>{{ 'PATIENT_SPACE.NAV.CHANGE_MODE' | translate }}</span>
  </ng-template>

  <div class="vc-switch-mode-dialog__body">
    <button
      type="button"
      class="vc-switch-mode-dialog__option"
      [class.is-active]="modeToSwitch === 'professional'"
      (click)="modeToSwitch = 'professional'"
      [disabled]="!availableModes.includes('professional')"
    >
      {{ 'ENTRY.MODE.PROFESSIONAL' | translate }}
    </button>
    <button
      type="button"
      class="vc-switch-mode-dialog__option"
      [class.is-active]="modeToSwitch === 'patient'"
      (click)="modeToSwitch = 'patient'"
      [disabled]="!availableModes.includes('patient')"
    >
      {{ 'ENTRY.MODE.PATIENT' | translate }}
    </button>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" severity="secondary" (click)="cancelSwitchMode()">
      {{ 'COMMON.CANCEL' | translate }}
    </button>
    <button pButton type="button" (click)="confirmSwitchMode()">
      {{ 'COMMON.ACCEPT' | translate }}
    </button>
  </ng-template>
</p-dialog>
